import Box from '@mui/material/Box';
import { useEffect, useRef, useState } from 'react';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import Icon from '../atoms/Icon';

export default function SimpleSearch({
  onFilter,
  initialFilter = '',
  placeholder = 'Filter results',
}: {
  onFilter: any;
  initialFilter?: string;
  placeholder?: string;
}) {
  const [term, setTerm] = useState<string>(initialFilter);
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    onFilter(term);
    if (term === '') {
      window.setTimeout(() => ref?.current?.focus(), 1000);
    }
    // eslint-disable-next-line
  }, [term]);
  return (
    <Box
      sx={{
        mx: 2,
        my: 1,
        display: 'flex',
        flex: 1,
      }}
    >
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <Icon.Search />
      </IconButton>
      <InputBase
        ref={ref}
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'filter results' }}
        value={term}
        onChange={(e: any) => setTerm(e.target.value)}
      />
      {term && (
        <IconButton
          onClick={() => setTerm('')}
          type="button"
          sx={{ p: '10px' }}
          aria-label="search"
        >
          <Icon.Clear />
        </IconButton>
      )}
    </Box>
  );
}
